export const GET_IS_CUSTOMER_CONSIP = "GET_IS_CUSTOMER_CONSIP";
export const GET_ORDINI_CONSIP_TABLE_DATA_AND_LOADING = "GET_ORDINI_CONSIP_TABLE_DATA_AND_LOADING"
export const GET_ORDINI_CONSIP_DETAILS = "GET_ORDINI_CONSIP_DETAILS";
export const GET_SIM_DA_ATTIVARE = "GET_SIM_DA_ATTIVARE";
export const GET_SIM_DA_ATTIVARE_LOADING = "GET_SIM_DA_ATTIVARE_LOADING";
export const GET_ORDINI_CONSIP_DETAILS_OFFERTA = "GET_ORDINI_CONSIP_DETAILS_OFFERTA";
export const GET_OFFERTA_ROW_DETAILS = "GET_OFFERTA_ROW_DETAILS";
export const GET_CONSIP_PLAN_AND_LOADING = 'GET_CONSIP_PLAN_AND_LOADING';
export const GET_SIM_PRIMARIA_DATA_AND_LOADING = "GET_SIM_PRIMARIA_DATA_AND_LOADING";
export const GET_SIM_SECONDARIA_SUMMARY_DATA = "GET_SIM_SECONDARIA_SUMMARY_DATA";
export const ATTIVA_SIM_SECONDARIA_REQUEST = "ATTIVA_SIM_SECONDARIA_REQUEST";